/**
 * @format
 * @description Premium Investing section page.
 * ARC-5323 Adds 'testVariant' page meta property
 */
export default {
  // available-slots-for-tier: {
  //   html: [[1, 1]],
  //   ldbd: [],
  //   boxr: [],
  //   boxs: [],
  //   boxs2: [],
  //   flex: [],
  //   flex2: [],
  //   flex3: [],
  // },
  mobile: {
    html: [[1, 1]],
    flex: [[300, 250]],
    flex2: [
      [300, 250],
      [300, 600]
    ],
    flex3: [[300, 250]]
  },
  portrait: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [768, 250]
    ],
    flex: [[300, 250]],
    flex2: [[300, 250]]
  },
  landscape: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1024, 250]
    ],
    boxs: [
      [300, 250],
      [300, 600]
    ],
    boxs2: [
      [300, 250],
      [300, 600]
    ]
  },
  desktop: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1000, 250],
      [1800, 250]
    ],
    boxr: [[300, 250]],
    boxs: [
      [300, 250],
      [300, 600]
    ],
    boxs2: [
      [300, 250],
      [300, 600]
    ]
  }
};
